export default "__VITE_ASSET__DEE_beyh__"